module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p06-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('b', [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("While writing this book, I was astounded to discover that many people had never even heard the word "), _c('i', [_vm._v("cryptozoology")]), _vm._v(". I was also amazed to find that many dictionaries and online word origin sources did not include the term. I did find a definition at "), _c('i', [_vm._v("AskOxford.com:")]), _vm._v(" “"), _c('b', [_vm._v("noun")]), _vm._v(" the search for animals whose existence is disputed or unsubstantiated, such as the Loch Ness monster.” Most cryptozoologists say it is “the study of hidden animals.” The term is credited to the “master of cryptozoology,” Bernard Heuvelmans and dates back to 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('i', [_vm._v("Cryptids")]), _vm._v(", the name for the creatures studied in this field, are not only beings whose existence has not yet been proven; the name is also given to creatures sighted in areas to which they are not indigenous. Cryptozoology can include the study of beings that have been considered extinct for thousands of years.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("There is debate among researchers and cryptozoologists regarding what creatures can be called cryptids. "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Many of the experts investigate only hairy humanoids, but some fringe cryptozoologists accept mystical creatures such as unicorns, fairies, and dragons. Traditional beasts such as vampires, werewolves, and zombies are often included in the spectrum as well. Ghostly entities, such as black dogs and shadow people, are sometimes found under the cryptid heading. We can't leave out the often-sighted aliens, which are believed to be the source of a great number of cryptid sightings.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("It was not an easy task deciding what cryptids to include in this book. I started out researching the more well-known creatures such as Big Foot, the Loch Ness monster, and the hairless beast mentioned often in the news lately, the "), _c('i', [_vm._v("Chupacabra")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Oh my goodness, the information available on Big Foot is amazing! Hundreds of thousands of volumes and online sources to read and research. In addition to Big Foot sightings recorded in most states, countries, and continents, there are reports of similar creatures using many different names. Some cryptozoologists classify other cryptids, such as the Ohio Grassman, the Beast of Bray Road, Goatman, and the New Jersey Devil, as Big Foot-type creatures.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The gray areas in the field of cryptozoology are immense at this time, as it is a relatively new area of study. There are thousands of hidden creatures that have been sighted all over our awesome world. Were you aware of the giant kangaroo sightings in the Midwest in the 1970s? Have you heard of the giant turtle living in "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Indiana? Did you know about the little boy in a small town in Illinois who, while playing hide-and-seek in his backyard, was picked up and carried 40 feet by a giant bird?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In addition to these documented creatures, there are many incredible cryptids that we don't normally hear about. I decided I might serve my readers best by delving into these lesser-known creatures, like the shocking Mongolian Death Worm, the Awful, the goblins of Kentucky, the Loogaroos vampires, the Ahool, and many more incredible and marvelous beasts. I've also included some of the cryptids that have been in the news over the years, such as the Boston Lemur, the Chupacabra, Mothman, and the giant rats of New York City.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("One of the most fascinating types of creature sighted in contemporary times is the rod or skyfish. I enjoyed researching this cryptid immensely, and am grateful to expert Jose Escamilla for his time and help on the subject. Thousands of articles, books, and videos have been written and produced by many talented, brave, and persistent researchers and cryptozoologists. Because of their often dangerous treks into the unknown, their travels to the locations of reported sightings, and their diligence in recording the information, I was able to write this field guide to help the novice cryptid hunter.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Look upon this book as an introduction to forty different incredible beasts. I have tried to provide the "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("information you need to know: where the creatures come from, where to find them, what traits and characteristics to look for, and how to prepare yourself for the search. At the end of the book is a Further Reading section, in which I list many of the sources on each cryptid. I have included references I used in my own research and also the sources of my sources!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p09-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.75pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I've looked at not only many cryptids from the United States, but also fascinating creatures from all over the world. Some can be found in your yard or even inside your own home! Many of these creatures are benign and would be delightful to encounter. There are others, though, that I've delineated more as a warning than as an enticement. I implore you to use great caution while searching for these hidden animals. Keep in mind the cautions I include for the more dangerous cryptids. The most important bit of advice I can give to you is to remember not to show your fear; most evil creatures gain their strength from our weaknesses. Appearing brave will give you courage. Good luck!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef78640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05-introduction.vue
// module id = 72
// module chunks = 0